import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Logs all Angular errors with full message, stack, and optional component context
 * to help diagnose issues like "prefix-decrement operator requires a reference expression".
 */
@Injectable()
export class ErrorLoggingHandler extends ErrorHandler {
  override handleError(error: unknown): void {
    const err = error instanceof Error ? error : new Error(String(error));
    console.error('[Angular Error]', {
      message: err.message,
      name: err.name,
      stack: err.stack,
      original: error,
    });
    if (err.stack) {
      console.error('[Angular Error] Full stack:\n', err.stack);
    }
    super.handleError(error);
  }
}
